import { useBetween } from 'use-between';
import { useEffect } from 'react';
import { UserDetailsUseBetween } from '../use-between/user-details-use-between';
import { getCurrentUser, getUserRecentSelection } from '../services';
import { User } from '../../components/client-panel/components/my-account-info/models/user.model';
import { UserSelection } from '../../components/client-panel/components/my-account-info/models/user-selection.model';
import { getEditedBuildingSite } from '../../containers/shopping-cart-container/building-sites/building-sites-form.service';
import { BuildingSiteFormViewModel } from '../../containers/shopping-cart-container/building-sites/building-sites-form-view.model';
import { syncBuildingSiteFromRecentSelection } from '../../components/shopping-cart/services/shopping-cart.service';
import { IBuildingSiteListViewDto } from '../../components/order/interfaces/building-site-list-view.interface';
import { ShoppingCartUseBetween } from '../../components/order/use-between/shopping-cart-use-between';
import { IShopingCart } from '../../components/order/interfaces/shopping-cart.interface';
import { Utils } from '../constants/utilities.constants';

export default function UserDetailsInitialize() {
    const { setUserDetails } = useBetween(UserDetailsUseBetween);
    const { setIsLoadingUserDetails } = useBetween(UserDetailsUseBetween);
    const { setUserSelection } = useBetween(UserDetailsUseBetween);
    const { setBuildingSite } = useBetween(ShoppingCartUseBetween);

    // These requests only pre-fill the session in the background. The user can log out (or fail to log in) while they
    // are in flight, so a rejected one must not surface as an unhandled promise rejection.
    const ignoreBackgroundFailure = (): void => undefined;

    const getAndSetCurrentUserDetails = () => {
        getCurrentUser()
            .then((response) => {
                if (response) {
                    const data: User = response.data;
                    setUserDetails(data);
                    setIsLoadingUserDetails(true);
                }
            })
            .catch(ignoreBackgroundFailure);
    };
    const getAndSetUserRecentSelection = () => {
        getUserRecentSelection()
            .then((response) => {
                if (response) {
                    const model: UserSelection = response.data;
                    if (model) {
                        handlUpdateOrAddBuildingSite(model.buildingSiteUuid);
                        setUserSelection(model);
                    }
                }
            })
            .catch(ignoreBackgroundFailure);
    };

    const handlUpdateOrAddBuildingSite = (buildingSiteUuid: string) => {
        if (buildingSiteUuid != Utils.defaultUuid) {
            getEditedBuildingSite(buildingSiteUuid)
                .then((response) => {
                    if (response) {
                        const model: BuildingSiteFormViewModel = response.data;
                        syncBuildingSiteFromRecentSelection({
                            id: buildingSiteUuid,
                            name: model.name,
                            code: model.code,
                            country: model.country,
                        } as IBuildingSiteListViewDto)
                            .then((response) => {
                                if (response) {
                                    const model: IShopingCart = response.data;
                                    setBuildingSite(model.buildingSite);
                                }
                            })
                            .catch(ignoreBackgroundFailure);
                    }
                })
                .catch(ignoreBackgroundFailure);
        }
    };
    useEffect(() => {
        getAndSetCurrentUserDetails();
        getAndSetUserRecentSelection();
    }, []);

    return <></>;
}
